import * as yup from 'yup';

const serverDataSchema = yup.object({
  buyer: yup
    .object({
      companyName: yup.string().required(),
      craftId: yup.string().required(),
    })
    .required(),
  target: yup
    .object({
      companyName: yup.string().required(),
      craftId: yup.string().required(),
    })
    .required(),
  table: yup.array().required(),
});

export function verifyServerData(data) {
  try {
    serverDataSchema.validateSync(data, { abortEarly: false });
    return { valid: true, errors: [] };
  } catch (err) {
    return {
      valid: false,
      errors: err.errors || [err.message],
    };
  }
}
